// Coordenadas a partir de una dirección (geocoding). Devuelve
// { latitude, longitude } o null si no se encontró o falló el servicio.
export const geocodeAddress = async (address) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`,
      { headers: { "Accept-Language": "es" } }
    );
    const data = await response.json();
    if (!data.length) return null;
    return { latitude: parseFloat(data[0].lat), longitude: parseFloat(data[0].lon) };
  } catch (error) {
    console.warn("No se pudo geocodificar la dirección:", error);
    return null;
  }
};

// Dirección legible a partir de coordenadas (reverse geocoding), p. ej.
// "Avenida Corrientes 1000, San Nicolás, Buenos Aires". null si falla.
export const reverseGeocodeAddress = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
      { headers: { "Accept-Language": "es" } }
    );
    const data = await response.json();
    const a = data?.address;
    if (!a) return data?.display_name || null;
    const street = [a.road || a.pedestrian || a.footway, a.house_number].filter(Boolean).join(" ");
    const parts = [
      street || data.name,
      a.suburb || a.neighbourhood,
      a.city || a.town || a.village || a.municipality,
      a.state,
    ].filter(Boolean);
    return [...new Set(parts)].join(", ") || data.display_name || null;
  } catch (error) {
    console.warn("No se pudo obtener la dirección:", error);
    return null;
  }
};

// Ciudad aproximada a partir de coordenadas (reverse geocoding), mismo
// servicio que ya usa getCountryFromCoordinates en homeUtils.js pero
// devolviendo la ciudad en vez del país — la usan cars.js/trips.js para
// priorizar resultados de la ciudad del usuario en el orden por defecto.
export const getCityFromCoordinates = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&addressdetails=1`,
      { headers: { "Accept-Language": "es" } }
    );
    const data = await response.json();
    const address = data?.address || {};
    return address.city || address.town || address.village || address.municipality || null;
  } catch (error) {
    console.error("Error al obtener la ciudad:", error);
    return null;
  }
};
